import apiClient from './apiClient';

// --- Mappers ---

export const mapCourseFromApi = (c) => {
  if (!c) return null;
  const id = c._id?.toString?.() ?? c.id;
  return {
    id,
    _id: c._id,
    title: c.title,
    description: c.description || '',
    basicVideoUrl: c.basicVideoUrl || '',
    basicVideoFileName: c.basicVideoFileName || '',
    imageUrl: c.imageUrl || '',
    imageFileName: c.imageFileName || '',
    duration: c.duration || '',
    rating: c.rating || 0,
    studentCount: c.studentCount || '',
    badges: Array.isArray(c.badges) ? c.badges : [],
    price: c.price ?? '',
    originalPrice: c.originalPrice ?? '',
    courseType: c.courseType === 'crypto' ? 'crypto' : 'indian',
    underGrowthPlan: Boolean(c.underGrowthPlan),
    lessons: Array.isArray(c.lessons) ? c.lessons : [],
    quiz: Array.isArray(c.quiz) ? c.quiz : [],
    reviews: Array.isArray(c.reviews) ? c.reviews : [],
    createdAt: c.createdAt,
    updatedAt: c.updatedAt,
  };
};

// --- Admin & public API helpers ---

export const getCourses = async () => {
  const { data } = await apiClient.get('/api/courses');
  return Array.isArray(data) ? data.map(mapCourseFromApi) : [];
};

export const getCourseById = async (id) => {
  const { data } = await apiClient.get(`/api/courses/${id}`);
  return mapCourseFromApi(data);
};

export const createCourse = async (payload) => {
  const { data } = await apiClient.post('/api/courses', payload);
  return mapCourseFromApi(data);
};

export const updateCourse = async (id, payload) => {
  const { data } = await apiClient.put(`/api/courses/${id}`, payload);
  return mapCourseFromApi(data);
};

export const deleteCourse = async (id) => {
  await apiClient.delete(`/api/courses/${id}`);
};

/** POST /api/courses/:id/enroll-free — add a ₹0 course to the current user's account */
export const enrollFreeCourse = async (courseId) => {
  const { data } = await apiClient.post(`/api/courses/${courseId}/enroll-free`);
  return data;
};

export const getCourseLessonProgress = async (courseId) => {
  const { data } = await apiClient.get(`/api/courses/${courseId}/progress`);
  return {
    courseId: data?.courseId,
    lessonStatuses: Array.isArray(data?.lessonStatuses) ? data.lessonStatuses : [],
  };
};

export const updateCourseLessonStatus = async (courseId, lessonIndex, status) => {
  const { data } = await apiClient.put(`/api/courses/${courseId}/lessons/${lessonIndex}/status`, {
    status,
  });
  return data;
};

export const getCourseReviews = async (courseId) => {
  const { data } = await apiClient.get(`/api/courses/${courseId}/reviews`);
  return Array.isArray(data?.reviews) ? data.reviews : [];
};

export const submitCourseReview = async (courseId, rating, review = '') => {
  const { data } = await apiClient.post(`/api/courses/${courseId}/reviews`, { rating, review });
  return data?.review || null;
};

export const deleteCourseReview = async (courseId, reviewId) => {
  const { data } = await apiClient.delete(`/api/courses/${courseId}/reviews/${reviewId}`);
  return data;
};

